import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const enumUpdateValueDialogStyle: StyleRulesCallback = () => {
  return {
    paperWidthMd: {
      width: '500px',
    },
  };
};

export default enumUpdateValueDialogStyle;
